/**
 * Targets for the call-to-action picker (email composer and Conversations):
 * the creator's or organization's published Production Pages and Live Rooms,
 * with upcoming episodes. Loaded when the picker opens.
 */
import { storableError } from '../util/errors';
import { ctaAPI } from '../api/clients/ctaAPI';

export const FETCH_CTA_TARGETS_REQUEST = 'app/ctaPicker/FETCH_CTA_TARGETS_REQUEST';
export const FETCH_CTA_TARGETS_SUCCESS = 'app/ctaPicker/FETCH_CTA_TARGETS_SUCCESS';
export const FETCH_CTA_TARGETS_ERROR = 'app/ctaPicker/FETCH_CTA_TARGETS_ERROR';

const initialState = {
  // key ('creator' or an orgId) -> { pages, liveRooms }
  byOwner: {},
  inProgress: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_CTA_TARGETS_REQUEST:
      return { ...state, inProgress: true, error: null };
    case FETCH_CTA_TARGETS_SUCCESS:
      return { ...state, inProgress: false, byOwner: { ...state.byOwner, [payload.key]: payload.targets } };
    case FETCH_CTA_TARGETS_ERROR:
      return { ...state, inProgress: false, error: payload };
    default:
      return state;
  }
}

export const ctaOwnerKey = orgId => orgId || 'creator';

export const fetchCtaTargets = ({ orgId = null } = {}) => async dispatch => {
  const key = ctaOwnerKey(orgId);
  dispatch({ type: FETCH_CTA_TARGETS_REQUEST });
  try {
    const response = await ctaAPI.targets(orgId);
    const body = response?.data ?? response;
    const targets = body?.data ?? { pages: [], liveRooms: [] };
    dispatch({ type: FETCH_CTA_TARGETS_SUCCESS, payload: { key, targets } });
    return targets;
  } catch (e) {
    dispatch({ type: FETCH_CTA_TARGETS_ERROR, payload: storableError(e), error: true });
    return null;
  }
};
